let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;
    setTimeout(function () {
    let templateName = document.body.getAttribute('data-template');
  // Dynamically load JavaScript files

  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/product-form.js?v=56043074768287964941779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/shopflo.bundle.js?v=26151");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/pubsub.js?v=26034608122085135261779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/cart-notification.js?v=133508293167896966491779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/constants.js?v=132983761750457495441779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/cart.js?v=95316439595850377071779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/cart-drawer.js?v=2239547715108954751779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-scroll-tab.js?v=110537738839353943101779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/collapsable-combo-section.js?v=62496326040323439081779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-available-offers.js?v=26151");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-details.js?v=114717867829024831851779088362");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-recom-prods.js?v=26151");
  // loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/edd-section.js?v=100119633110064442781779088362");
  

  
  
    

  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/collapsible-content.css?v=69792250384829907791779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-accordion.css?v=181330424127687678861779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-social-reviews.css?v=74717896916299017681779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-available-offers.css?v=112077318425957018091779088362"); 
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-scroll-tab.css?v=116609938375906285541779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/new_serums_section.css?v=169911888615296355471779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/sunscreen-quiz-pdp.css?v=150892412449710366031779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/new-details-collapsable.css?v=21783054330784661661779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-color-swatch.css?v=44657734777189145271779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/all.min.css?v=36347114306294163891779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-price.css?v=70172745017360139101779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-card.css?v=90531592475021317501779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart.css?v=49529066954642232561779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-mega-menu.css?v=3343104478291901121779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-totals.css?v=59014315448263284001779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-drawer.css?v=41189841170916328551779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-discounts.css?v=152760482443307489271779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/searchtap.css?v=72127222885983381071779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-list-menu.css?v=151968516119678728991779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-search.css?v=165164710990765432851779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-menu-drawer.css?v=20646116693146970981779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-notification.css?v=54116361853792938221779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-cart-items.css?v=47901327362710772261779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-collection-hero.css?v=150137544140055157131779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/quick-add.css?v=66647833350618835731779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-show-more.css?v=139536189637226996221779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-swatch-input.css?v=61683592951238328641779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/component-swatch.css?v=68619770617697936771779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/collapsable-combo-section.css?v=16640933633868879741779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-feature-svg.css?v=107811230276467158871779088362");
  loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/npdp-recom-prods.css?v=42018924242700305821779088362");
  // loadCSS("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/edd-section.css?v=83095769838655511641779088362");


   
  // Remove invalid HTML and use JavaScript to load the script
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/details-modal.js?v=119528565511025453401779088362");
  loadScript("//dotandkeyuat.dotandkey.com/cdn/shop/t/194/assets/details-disclosure.js?v=13653116266235556501779088362");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);   
  }, 10);

}
// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true; // Ensure scripts are executed in order
  document.head.appendChild(script);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
